import { render, staticRenderFns } from "./PublishSuccessModal.vue?vue&type=template&id=3a8278d8&scoped=true"
import script from "./PublishSuccessModal.vue?vue&type=script&lang=js"
export * from "./PublishSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./PublishSuccessModal.vue?vue&type=style&index=0&id=3a8278d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8278d8",
  null
  
)

export default component.exports